import React from 'react';
import phrasesType from '../proptypes/phrases';
import PageSection from '../design-system/PageSection';
import Container from '../design-system/Containers';
import { LinkButton } from '../design-system/Buttons';
import Paragraph from '../design-system/Paragraph';
import { HeadingLabel, HeadingSection } from '../design-system/Headings';

const WhichSpyModule = ({
  phrases: { ctaTitle, ctaSubtitle, ctaButtonAlternative },
}) => (
  <PageSection center bgGradUp borderT>
    <HeadingSection>{ctaTitle}</HeadingSection>
    <HeadingLabel>{ctaSubtitle}</HeadingLabel>
    <Container center>
      <Paragraph>
        <LinkButton href="/" primary w100>
          Visit the experience
        </LinkButton>
        {ctaButtonAlternative}
        <LinkButton href="/profiles" secondary>
          Try our online profile
        </LinkButton>
      </Paragraph>
    </Container>
  </PageSection>
);

WhichSpyModule.propTypes = {
  phrases: phrasesType.isRequired,
};

export default WhichSpyModule;
